import React, { FC, useLayoutEffect, useRef, useState } from 'react';
import clsx from 'clsx';

interface TruncatedTextProps {
    text: string | number;
    style?: React.CSSProperties;
    className?: string;
    isCursorPointer?: boolean;
}

/**
 * Компонент для текста с обрезкой по ширине, и выводом полного текста при наведении
 *
 * @param text Тело: текст или число
 * @param style Inline стили для текста
 * @param className CSS классы для текста
 * @param isCursorPointer Кликабельный ли текст
 */

export const TruncatedText: FC<TruncatedTextProps> = React.memo(
    ({ text, style, className, isCursorPointer }: TruncatedTextProps) => {
        const [isTextTruncated, setIsTextTruncated] = useState(false);
        const [textContent] = useState<string>(String(text));

        const textRef = useRef<HTMLDivElement>(null);

        useLayoutEffect(() => {
            const check = () => {
                if (textRef.current) {
                    const el = textRef.current;
                    if (el.offsetWidth > 0 || el.offsetHeight > 0) {
                        setIsTextTruncated(
                            el.scrollWidth > el.clientWidth ||
                                el.scrollHeight > el.clientHeight
                        );
                    }
                }
            };

            check();

            const fallback = setTimeout(check, 100);

            window.addEventListener('resize', check);
            return () => {
                clearTimeout(fallback);
                window.removeEventListener('resize', check);
            };
        }, [textContent]);

        return (
            <div className="relative max-w-full group">
                <div
                    className={clsx(
                        className,
                        'overflow-hidden truncate text-nowrap',
                        isCursorPointer ? 'cursor-pointer' : 'cursor-default'
                    )}
                    style={style}
                    ref={textRef}
                >
                    <span title={isTextTruncated ? textContent : undefined}>
                        {textContent}
                    </span>
                </div>
            </div>
        );
    }
);
